export { SidePanelNav } from './SidePanelNav'
export { SidePanelLayout } from './SidePanelLayout'
export { useSidePanelNavCollapse } from './useSidePanelNavCollapse'
export { useIsDesktopNav } from './useIsDesktopNav'
export type { SidePanelNavGroup, SidePanelNavItem, SidePanelNavProps } from './types'

export const SETTINGS_NAV_COLLAPSED_STORAGE_KEY = 'rxpad.settingsNavCollapsed'
export const REPORTS_NAV_COLLAPSED_STORAGE_KEY = 'rxpad.rptNavCollapsed'
